var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"conversationsWrapper"},[_c('v-card',{staticClass:"conversationsContainer d-flex flex-row-reverse flex-wrap-reverse",attrs:{"flat":""}},[_vm._l((_vm.conversationsOpen),function(c){return [_c('ConversationBox',{key:c.id,attrs:{"conversation":c}})]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }